import { render, staticRenderFns } from "./AdministrationCode.vue?vue&type=template&id=27843c09&scoped=true"
import script from "./AdministrationCode.vue?vue&type=script&lang=js"
export * from "./AdministrationCode.vue?vue&type=script&lang=js"
import style0 from "./AdministrationCode.vue?vue&type=style&index=0&id=27843c09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27843c09",
  null
  
)

export default component.exports